module.exports = __webpack_public_path__ + "img/risk3.49210095.png";